import RoutesMap from "route_control/RouteControl"
import { ActivePlanList, FuturePlanList, PlanHistoryList } from "pages/plans"

const PlansRoute = () => {
    return [
        {
            path: RoutesMap.ACTIVE_PLAN.path,
            element: <ActivePlanList />
        },
        {
            path: RoutesMap.FUTURE_PLAN.path,
            element: <FuturePlanList />
        },
        {
            path: RoutesMap.PLAN_HISTORY.path,
            element: <PlanHistoryList />
        },
    ]
}

export default PlansRoute;
